module.exports = __webpack_public_path__ + "img/support-light.b5cbe313.svg";